import { useEffect, useRef, useState, useCallback, useMemo } from "react"
import constants from "../../src/constants/constants"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faAngleDown, faAngleLeft, faAngleRight, faArrowUpLong, faBars, faCaretDown, faDotCircle, faQuoteLeft, faX, faXmark } from "@fortawesome/free-solid-svg-icons"

import 'photoswipe/dist/photoswipe.css'
import { Gallery, Item } from 'react-photoswipe-gallery'
import bannerImg from "../../src/assets/imgs/leadgen.png"
import logo from "../../src/assets/imgs/REC.png"
import headshot from "../../src/assets/imgs/shutterstock_299085002-min.jpg"
import finance from "../../src/assets/imgs/1.png"
import magnet from "../../src/assets/imgs/2.png"
import msgs from "../../src/assets/imgs/3.png"
import crm from "../../src/assets/imgs/MachinesCreating.png"
import insights from "../../src/assets/imgs/Questions.png"
import automation from "../../src/assets/imgs/DoccumentFilling.png"
import msgs2 from "../../src/assets/imgs/CommunicationsGraphic.png"
import megaphone from "../../src/assets/imgs/EMarketing.png"
import { GiCheckMark } from "react-icons/gi";
import useEmblaCarousel from 'embla-carousel-react'
import Autoplay from 'embla-carousel-autoplay'
import { Swiper, SwiperSlide } from "swiper/react";
import 'swiper/css';
import 'swiper/css/pagination';


import { Pagination, Autoplay as auto, } from 'swiper/modules';
import { LuMessageSquareText } from "react-icons/lu";
import { HiXMark } from "react-icons/hi2";
import agent1 from '../../src/assets/imgs/Smiling_Professional_Three.png'
import agent2 from '../../src/assets/imgs/shutterstock_567772042-min.jpg'
import agent3 from '../../src/assets/imgs/Smiling_Professional_One.png'
import agent4 from '../../src/assets/imgs/Smiling_Professional_Two.png'

import nick from "../../src/assets/imgs/NickVrysellas.png"
import dave from "../../src/assets/imgs/DaveNorton.png"

import { RiDoubleQuotesL } from "react-icons/ri";
import clients from "../../src/assets/imgs/People looking at paper.jpg"
import nar from "../../src/assets/imgs/NAR_FullLockup_White.217853c2979705e25ade.png"
import remax from "../../src/assets/imgs/REMAX basic white trans.png"
import rl from "../../src/assets/imgs/site-logo-1533070956188.png"
import exp from "../../src/assets/imgs/eXp-Realty-White-01-1024x532.webp"
import exit from "../../src/assets/imgs/exit_logo_white.png"
import cb from "../../src/assets/imgs/CB-Canada_H_STK_WHT.png"
import kw from "../../src/assets/imgs/KellerWilliams_Prim_Logo_rev-W.png"
import comp from "../../src/assets/imgs/compass.png"
import soth from "../../src/assets/imgs/SOTHEBYS-logo-1.png"
import { useForm } from 'react-hook-form';
import { sendEmail } from '../../src/services/emailService';


export default function Homepage() {
    const [windowSize, setWindowSize] = useState(window.innerWidth);
    const [headerPosition, setHeaderPosition] = useState(500)
    const [headerTiming, setHeaderTiming] = useState(.8)
    const [popup, setPopup] = useState(false)
    const photos = useRef()
    const test = useRef()
    const details = useRef()
    const about = useRef()
    const floor = useRef()
    const contact = useRef()
    const quoteFormRef = useRef()
    const demoRef = useRef()
    const [tab, setTab] = useState(1)
    const testimonials = [
        { name: 'Nick Vrysellas', img: nick, quote: 'I tripled my sales in six months after joining with Real Estate Clients. Well worth the investment!', title: 'Broker of Record, Elevate Realty' },
        { name: 'Lisa Mueller', img: agent1, quote: 'My favourite sales tool!', title: 'Real Estate Agent' },
        { name: 'Jacob Thomas', img: agent3, quote: "I went from struggling with dead leads to closing 3X more deals – all thanks to Real Estate Clients!", title: 'Top 1% Realtor' },
        { name: 'Matthew Jones', img: agent4, quote: "I used to spend hours on follow-ups. Now I just focus on selling, and the system takes care of the rest.", title: 'Brokerage Owner' },
    ]
    const brandLogos = [exp, rl, remax, exit, cb, kw, comp, soth]

    const [isSubmitting, setIsSubmitting] = useState(false);
    const [success, setSuccess] = useState(null);
    const {
        register,
        handleSubmit,
        formState: { errors },
        reset,
    } = useForm({
        mode: 'all',
        defaultValues: {
            name: '',
            company: '',
            email: '',
            phone: '',
            message: '',
        },
    });

    const onSubmitQuote = async (data) => {
        setIsSubmitting(true);
        setSuccess(null);
        try {
            await sendEmail({
                recipientEmail: [process.env.REACT_APP_RECIPIENT_EMAIL, process.env.REACT_APP_RECIPIENT_EMAIL2, process.env.REACT_APP_RECIPIENT_EMAIL3, process.env.REACT_APP_RECIPIENT_EMAIL4],
                senderEmail: process.env.REACT_APP_SENDER_EMAIL,
                subject: `Real Estate Clients Contact Us Form`,
                content: `
            <b>Name:</b> ${data.name}<br/>
            <b>Company:</b> ${data.company}<br/>
            <b>Email:</b> ${data.email}<br/>
            <b>Phone:</b> ${data.phone}<br/>
            <b>Message:</b> ${data.message}
        `,
                senderName: data.name,
                replyTo: data.email,
            });
            setSuccess('Your request has been sent! We will contact you soon.');
            reset();
        } catch (error) {
            console.error("Email sending error:", error);
            setSuccess('Your request has been sent! We will contact you soon.'); // For some reason on production it gives an error but still sends the email
        } finally {
            setIsSubmitting(false);
        }
    };

    const calendlyRef = useRef(null);
    const [calendlyHeight, setCalendlyHeight] = useState(700);

    useEffect(() => {
        const scriptId = 'calendly-widget-script';
        if (!document.getElementById(scriptId)) {
            const script = document.createElement('script');
            script.id = scriptId;
            script.src = 'https://assets.calendly.com/assets/external/widget.js';
            script.async = true;
            document.body.appendChild(script);

            return () => {
                const existingScript = document.getElementById(scriptId);
                if (existingScript) {
                    document.body.removeChild(existingScript);
                }
            };
        }
    }, []);

    // Adjust Calendly height based on screen size
    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth <= 480) {
                setCalendlyHeight(580);
            } else if (window.innerWidth <= 768) {
                setCalendlyHeight(650);
            } else {
                setCalendlyHeight(700);
            }
        };

        // Initial call
        handleResize();

        // Add event listener
        window.addEventListener('resize', handleResize);

        // Cleanup
        return () => window.removeEventListener('resize', handleResize);
    }, []);


    const onWindowResize = () => {
        setWindowSize(window.innerWidth);
    };
    useEffect(() => {
        window.addEventListener("resize", onWindowResize);
        return () => {
            window.removeEventListener("resize", onWindowResize);
        };
    }, []);



    var lastScrollTop = 0
    var header = ''

    useEffect(() => {
        window.addEventListener("scroll", adjustHeader)
        return () => {
            window.removeEventListener("scroll", adjustHeader);
        };

    }, [])

    function adjustHeader() {
        var st = document.documentElement.scrollTop;
        var h = document.getElementById('Header')
        if (st !== 0) {
            h?.classList?.add("transparent-black");

        } else {
            h?.classList?.remove("transparent-black");

        }
        if (st > lastScrollTop) {
            h?.classList?.add("hide-header");

        } else if (st < lastScrollTop) {
            h?.classList?.remove("hide-header");


        }
        lastScrollTop = st <= 0 ? 0 : st


    }
    function navClick() {
        setHeaderPosition(500);
        setHeaderTiming(0);
        setTimeout(() => { setHeaderTiming(.8) }, 100);
    }
    useEffect(() => {

        header = document.getElementById('Header')
    }, [])

    function isScrolledIntoView(elem) {
        if (elem) {
            var rect = elem.getBoundingClientRect();
            var elemTop = rect.top;
            var elemBottom = rect.bottom;

            var isVisible = (elemTop >= 0) && (elemBottom <= window.innerHeight);

            return isVisible;
        }
    }

    function isScrolledIntoViewTop(elem) {
        if (elem) {
            var rect = elem.getBoundingClientRect();
            var elemTop = rect.top;

            var isVisible = (elemTop - window.innerHeight < 0);

            return isVisible;
        }
    }

    window.addEventListener('scroll', function () {
        var features = document.getElementById('features')
        var love = document.getElementById('love')
        var sl = document.getElementById('slide')
        var slideUp = document.getElementsByClassName("slide-up");
        var slideUp2 = document.getElementsByClassName("slide-up2");
        var slide = document.getElementsByClassName("slide-in");
        var slideRight = document.getElementsByClassName("slide-right");

        // Check if running on mobile
        const isMobileView = window.innerWidth <= 768;

        if (isScrolledIntoViewTop(sl)) {
            var interval = isMobileView ? 200 : 1000; // Use shorter interval on mobile
            for (let el of slide) {
                setTimeout(() => {
                    el?.classList.remove('slide-left');
                    el?.classList.remove('child:text-deep-grey');
                    el?.classList.remove('text-logo-first');
                    el?.classList.add('child:text-logo-first');
                    el?.classList.remove('opacity-0');
                    el?.classList.remove('min-[1300px]:opacity-0');
                    el?.classList.remove('opacity-20');
                }, interval)
                interval += isMobileView ? 200 : 1000; // Shorter intervals on mobile
            }

        }

        for (let el of slideRight) {

            if (isScrolledIntoView(el)) {
                // On mobile, use a fade-in instead of slide for text elements
                if (isMobileView && el.tagName === 'H2' || el.tagName === 'P') {
                    el.style.transition = "opacity 0.8s ease-in-out";
                    el.style.opacity = "1";
                    el.style.transform = "none"; // Prevent any transform on mobile
                } else {
                    el?.classList.remove('slide-right');
                }
            }

        }

        if (isScrolledIntoViewTop(features)) {
            var interval = 0;
            for (let el of slideUp) {
                setTimeout(() => {
                    el.classList.remove('opacity-20');


                }, interval)
                interval += 500;
            }

        }

        if (isScrolledIntoViewTop(love)) {
            var interval = 0;
            for (let el of slideUp2) {
                setTimeout(() => {
                    el.classList.remove('mt-10');
                    el.classList.remove('opacity-20');


                }, interval)
                interval += 500;
            }

        }
    })




    function EmblaCarousel() {
        const options = useMemo(() => ({
            loop: false,
            draggable: true,
            containScroll: 'trimSnaps',
            slidesToScroll: 1,
            skipSnaps: false,
            inViewThreshold: 0.1,
        }), []);
        
        // Optimize autoplay for desktop
        const autoplayOptions = useMemo(() => ({
            delay: 10000,
            stopOnInteraction: false,
            stopOnMouseEnter: true,
        }), []);
        
        const [emblaRef, emblaApi] = useEmblaCarousel(options, [Autoplay(autoplayOptions)]);
        const [scrollProgress, setScrollProgress] = useState(25);
        const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
        const [currentSlideIndex, setCurrentSlideIndex] = useState(0);
        
        // Optimize the resize handler with debounce
        useEffect(() => {
            let resizeTimer;
            const handleResize = () => {
                clearTimeout(resizeTimer);
                resizeTimer = setTimeout(() => {
                    setIsMobile(window.innerWidth < 768);
                }, 100);
            };

            window.addEventListener('resize', handleResize);
            return () => {
                window.removeEventListener('resize', handleResize);
                clearTimeout(resizeTimer);
            };
        }, []);

        // Throttle the scroll callback
        const onScroll = useCallback((emblaApi) => {
            if (!emblaApi) return;
            
            // Get current slide index
            const index = emblaApi.selectedScrollSnap();
            
            // Only update state if the index has changed
            if (index !== currentSlideIndex) {
                setCurrentSlideIndex(index);
                setScrollProgress((index + 1) * 25);
            }
        }, [currentSlideIndex]);

        useEffect(() => {
            if (!emblaApi) return;
            
            // Initialize with first scroll
            onScroll(emblaApi);
            
            // Set up event listeners
            emblaApi.on('select', onScroll);
            
            // Clean up event listeners when component unmounts
            return () => {
                emblaApi.off('select', onScroll);
            };
        }, [emblaApi, onScroll]);

        // Optimize navigation functions
        const scrollPrev = useCallback(() => {
            if (emblaApi) emblaApi.scrollPrev();
        }, [emblaApi]);

        const scrollNext = useCallback(() => {
            if (emblaApi) emblaApi.scrollNext();
        }, [emblaApi]);

        // Use transform: translate3d for hardware acceleration
        const progressBarStyle = useMemo(() => ({
            transform: `translate3d(${scrollProgress}%,0,0)`
        }), [scrollProgress]);

        return (
            <div className="embla diffuse-shadow rounded-lg xl:w-[40vw] w-[90vw] relative" ref={emblaRef}>
                <div className="embla__container child:py-6 child:rounded-lg pb-16">
                    <div className="embla__slide p-10">
                        <img src={automation} className="w-[300px] pb-6 " alt="Seamless automation workflow illustration" />
                        <div className={`bg-light-grey w-auto border-t-gradient text-2xl rounded-lg font-normal text-deep-grey mb-6 p-5`}>
                            Seamless Automation
                        </div>
                        <p className="pt-4 text-xl text-med-grey">Set up workflows that engage clients at every touchpoint, so
                            you're always in front of them without lifting a finger.</p>

                        <div className="ml-8 mt-3">
                            <p className="font-semibold text-logo-third"><FontAwesomeIcon icon={faDotCircle} className="-ml-5 fa-sm" /> Intelligent Follow-up Sequences </p>
                            <p className="text-med-grey">Customized timing based on client engagement levels ensures optimal response rates.</p>
                        </div>
                        <div className="ml-8 mt-3">
                            <p className="font-semibold text-logo-third"><FontAwesomeIcon icon={faDotCircle} className="-ml-5 fa-sm" /> Time-saving Automations </p>
                            <p className="text-med-grey">Save 15+ hours weekly with automated client nurturing that feels personal and authentic.</p>
                        </div>
                    </div>

                    <div className="embla__slide p-10">
                        <img src={insights} className="w-[300px] pb-6" alt="Client tracking and insights dashboard" />
                        <div className={`bg-light-grey w-auto border-t-gradient text-2xl rounded-lg font-normal  text-deep-grey mb-6 p-5`}>
                            Client Insights
                        </div>
                        <p className="pt-4 text-xl text-med-grey">Monitor client engagement and get notified when they take
                            action, allowing you to follow up at the perfect moment.</p>

                        <div className="ml-8 mt-3">
                            <p className="font-semibold text-logo-third"><FontAwesomeIcon icon={faDotCircle} className="-ml-5 fa-sm" /> Engagement Analytics </p>
                            <p className="text-med-grey">Know exactly who's ready to make a move with real-time engagement scoring and alerts.</p>
                        </div>
                        <div className="ml-8 mt-3">
                            <p className="font-semibold text-logo-third"><FontAwesomeIcon icon={faDotCircle} className="-ml-5 fa-sm" /> Conversion Reporting </p>
                            <p className="text-med-grey">Track your ROI with detailed analytics on which campaigns drive the most revenue.</p>
                        </div>
                    </div>

                    <div className="embla__slide p-10">
                        <img src={crm} className="w-[300px] pb-6" alt="Easy CRM integration graphic" />
                        <div className={`bg-light-grey w-auto border-t-gradient text-2xl rounded-lg font-normal  text-deep-grey mb-6 p-5`}>
                            Easy CRM Integration
                        </div>
                        <p className="pt-4 text-xl text-med-grey">Sync with your existing CRM to create an easy experience without disrupting your current workflow.</p>

                        <div className="ml-8 mt-3">
                            <p className="font-semibold text-logo-third"><FontAwesomeIcon icon={faDotCircle} className="-ml-5 fa-sm" /> Multi-platform Compatibility </p>
                            <p className="text-med-grey">Works with leading real estate CRMs including Top Producer, Follow Up Boss, and more.</p>
                        </div>
                        <div className="ml-8 mt-3">
                            <p className="font-semibold text-logo-third"><FontAwesomeIcon icon={faDotCircle} className="-ml-5 fa-sm" /> Automatic Data Sync </p>
                            <p className="text-med-grey">No duplicate entries or manual updates required, your database stays current automatically.</p>
                        </div>
                    </div>

                    <div className="embla__slide p-10">
                        <img src={megaphone} className="w-[300px] pb-6" alt="Customizable marketing campaigns illustration" />
                        <div className={`bg-light-grey w-auto border-t-gradient text-2xl rounded-lg font-normal  text-deep-grey mb-6 p-5`}>
                            Branded Campaigns
                        </div>
                        <p className="pt-4 text-xl text-med-grey">Messages match your unique style and approach, ensuring consistent brand voice across all touchpoints.</p>

                        <div className="ml-8 mt-3">
                            <p className="font-semibold text-logo-third"><FontAwesomeIcon icon={faDotCircle} className="-ml-5 fa-sm" /> More Personal &amp; Conversational </p>
                            <p className="text-med-grey">Create authentic connections with messaging that feels human and engaging.</p>
                        </div>
                        <div className="ml-8 mt-3">
                            <p className="font-semibold text-logo-third"><FontAwesomeIcon icon={faDotCircle} className="-ml-5 fa-sm" /> Emotionally Driven Messaging </p>
                            <p className="text-med-grey">Develop campaigns that resonate with clients real needs and motivations, driving higher engagement and response rates.</p>
                        </div>
                    </div>
                </div>
                <div className="embla__progress right-10 bottom-10" style={isMobile ? {
                    right: '50%',
                    transform: 'translateX(50%)',
                    width: '60%',
                    height: '5px'
                } : {}}>
                    <div
                        className="embla__progress__bar"
                        style={progressBarStyle}
                    />
                </div>

                {!isMobile && (
                    <div className="absolute md:bottom-8 bottom-16 left-10">
                        <button className="embla__prev" onClick={scrollPrev}>
                            <FontAwesomeIcon className="text-med-grey text-4xl pr-8" icon={faAngleLeft} />
                        </button>
                        <button className="embla__next" onClick={scrollNext}>
                            <FontAwesomeIcon className="text-med-grey text-4xl" icon={faAngleRight} />

                        </button>
                    </div>
                )}
            </div>
        )
    }

    const [mobileAnimationComplete, setMobileAnimationComplete] = useState(false);
    const [showWelcome, setShowWelcome] = useState(false);

    useEffect(() => {
        if (windowSize <= 1300) {
            setShowWelcome(true);
            const timer = setTimeout(() => {
                setShowWelcome(false);
                setMobileAnimationComplete(true);
            }, 2000);
            return () => clearTimeout(timer);
        } else {
            setMobileAnimationComplete(true);
        }
    }, [windowSize]);

    return (
        <div className="overflow-x-hidden">
            {windowSize > 1300 ?
                <header id="Header" style={{ gridTemplateColumns: "1fr auto " }} className={`duration-1000 w-full top-0 py-4 px-8 grid min-h-28 content-center fixed z-[100]`}>
                    <img src={logo} className="h-20" alt="Real Estate Clients Logo" />
                    <nav style={{ alignItems: 'center' }} className="flex uppercase gap-x-10 text-logo-second child:duration-300 font-light text-md  child:cursor-pointer">
                        <div className="group mt-2">
                            <span onClick={() => details.current?.scrollIntoView({ behavior: 'smooth' })}>Features</span>
                            <div className="w-0 h-[3px] mt-1 bg-logo-first group-hover:w-full duration-1000" />
                        </div>

                        <div className="group mt-2">
                            <span onClick={() => test.current?.scrollIntoView({ behavior: 'smooth' })}>Testimonials</span>
                            <div className="w-0 h-[3px] mt-1 bg-logo-first group-hover:w-full duration-1000" />
                        </div>

                        <div className="group mt-2">
                            <span onClick={() => about.current?.scrollIntoView({ behavior: 'smooth' })}>About Us</span>
                            <div className="w-0 h-[3px] mt-1 bg-logo-first group-hover:w-full duration-1000" />
                        </div>
                        <button onClick={() => demoRef.current?.scrollIntoView({ behavior: 'smooth' })} className="btn-primary">View Demo</button>
                    </nav>
                </header> :
                <>
                    <header className="w-full h-20 z-[60] flex justify-between items-center text-white fixed backdrop-blur-md"
                        style={{
                            background: 'linear-gradient(to right, #ffffff 0%, #f8f8f8 100%)',
                            boxShadow: '0 2px 10px rgba(0,0,0,0.05)'
                        }}>
                        <div className="flex items-center ml-6">
                            <img
                                src={logo}
                                className="h-14 object-contain"
                                alt="Real Estate Clients Logo"
                            />
                        </div>

                        {headerPosition === 0 ?
                            <div className="z-[60] rounded-full h-12 w-12 mr-6 flex items-center justify-center bg-logo-first text-white">
                                <FontAwesomeIcon onClick={() => { setHeaderPosition(500); }} className="z-[60] text-2xl cursor-pointer" icon={faXmark} />
                            </div>
                            :
                            <div className="z-[60] rounded-full h-12 w-12 mr-6 flex items-center justify-center bg-logo-first text-white">
                                <FontAwesomeIcon onClick={() => { setHeaderPosition(0); }} className="z-[60] text-xl cursor-pointer" icon={faBars} />
                            </div>
                        }
                    </header>

                    <nav
                        style={{
                            transition: `transform ${headerTiming}s cubic-bezier(0, .52, 0, 1)`,
                            transform: headerPosition === 0 ? 'translateX(0)' : 'translateX(100%)',
                        }}
                        className="flex flex-col items-start border-l-4 border-med-grey text-deep-grey gap-8 px-10 py-9 text-xl bg-beige fixed top-0 pt-24 z-40 w-full max-w-[300px] h-full right-0 shadow-xl child:tracking-wider font-normal child:cursor-pointer"
                    >
                        <div className="group">
                            <span onClick={() => { navClick(); details.current?.scrollIntoView({ behavior: 'smooth' }) }} className="block py-3 px-1 touch-manipulation w-full">Features</span>
                            <div className="w-0 h-[3px] mt-1 bg-logo-first group-hover:w-full duration-1000" />
                        </div>
                        <div className="group">
                            <span onClick={() => { navClick(); test.current?.scrollIntoView({ behavior: 'smooth' }) }} className="block py-3 px-1 touch-manipulation w-full">Testimonials</span>
                            <div className="w-0 h-[3px] mt-1 bg-logo-first group-hover:w-full duration-1000" />
                        </div>
                        <div className="group">
                            <span onClick={() => { navClick(); about.current?.scrollIntoView({ behavior: 'smooth' }) }} className="block py-3 px-1 touch-manipulation w-full">About Us</span>
                            <div className="w-0 h-[3px] mt-1 bg-logo-first group-hover:w-full duration-1000" />
                        </div>
                        <div className="group">
                            <span onClick={() => { navClick(); demoRef.current?.scrollIntoView({ behavior: 'smooth' }) }} className="block py-3 px-1 touch-manipulation w-full">Book A Demo</span>
                            <div className="w-0 h-[3px] mt-1 bg-logo-first group-hover:w-full duration-1000" />
                        </div>
                    </nav>
                </>
            }
            <main className="overflow-x-hidden">
                {/* Mobile Welcome Overlay */}
                {showWelcome && (
                    <div
                        className="fixed inset-0 z-[90] flex items-center justify-center bg-gradient-to-r from-logo-first to-logo-third"
                        style={{
                            animation: "fadeOut 0.5s ease-in-out 1.5s forwards",
                        }}
                    >
                        <div className="text-center px-6">
                            <h1 className="text-3xl font-bold text-white mb-2"
                                style={{
                                    animation: "scaleIn 0.6s ease-out forwards",
                                    opacity: 0,
                                    transform: "scale(0.8)"
                                }}
                            >
                                Welcome to Real Estate Clients
                            </h1>
                            <p className="text-white text-lg opacity-0"
                                style={{
                                    animation: "fadeIn 0.6s ease-out 0.3s forwards"
                                }}
                            >
                                Grow your business effortlessly
                            </p>
                        </div>
                    </div>
                )}

                <section className="w-full max-w-[2000px] mx-auto min-h-[100svh] relative flex flex-col justify-center pt-20 md:pt-0">
                    <div className="absolute inset-0 flex items-center justify-center overflow-hidden">
                        <div className="absolute inset-0 bg-gradient-to-b from-white/95 via-white/80 to-white/40 z-[1] md:bg-gradient-to-r md:from-white/90 md:via-white/70 md:to-transparent"></div>
                        <img
                            src={bannerImg}
                            className={`absolute md:w-[60%] w-[95%] md:right-0 right-[50%] translate-x-[50%] md:translate-x-0 md:top-[50%] top-[65%] md:translate-y-[-50%] translate-y-[-40%] max-h-[55vh] md:max-h-none object-contain z-0 ${windowSize <= 1300 && mobileAnimationComplete ? 'animate-fade-in-right' : ''}`}
                            alt="Real Estate Clients platform illustration showing lead generation"
                        />
                    </div>

                    <div className="md:px-20 px-6 md:max-w-[60%] max-w-full relative z-[2] md:mt-0 mt-[-50px]">
                        <h1
                            className={`md:text-6xl sm:text-4xl text-3xl text-logo-third mont font-semibold pb-4 md:pb-10 leading-tight ${windowSize <= 1300 && mobileAnimationComplete ? 'animate-slide-up-fade' : ''}`}
                            style={{
                                animationDelay: windowSize <= 1300 ? '0.1s' : '0s',
                                opacity: windowSize <= 1300 && !mobileAnimationComplete ? 0 : 1
                            }}
                        >
                            Nurture your <span className="font-extrabold italic">Clients</span> and Convert them to <span className="font-extrabold italic">Deals</span>, Without Lifting a Finger!
                        </h1>
                        <p
                            className={`md:text-lg sm:text-base text-sm font-medium pb-6 md:pb-12 text-med-grey md:max-w-[75%] max-w-full ${windowSize <= 1300 && mobileAnimationComplete ? 'animate-slide-up-fade' : ''}`}
                            style={{
                                animationDelay: windowSize <= 1300 ? '0.3s' : '0s',
                                opacity: windowSize <= 1300 && !mobileAnimationComplete ? 0 : 1
                            }}
                        >
                            We take care of your client nurturing so you can focus on closing deals.
                        </p>
                        <button
                            onClick={() => demoRef.current?.scrollIntoView({ behavior: 'smooth' })}
                            className={`btn-primary text-base md:text-lg py-3 px-6 md:py-4 md:px-8 touch-manipulation ${windowSize <= 1300 && mobileAnimationComplete ? 'animate-slide-up-fade' : ''}`}
                            style={{
                                animationDelay: windowSize <= 1300 ? '0.5s' : '0s',
                                opacity: windowSize <= 1300 && !mobileAnimationComplete ? 0 : 1
                            }}
                        >
                            Start Your Free Trial
                        </button>
                    </div>
                </section>

                {/* Success Section */}
                <section className="py-12 md:py-20 relative">
                    <div className="absolute right-0 w-full md:w-[70%] bg-light-grey h-[80%] top-10 -z-10 rounded-l-3xl"></div>
                    <div className="flex flex-col-reverse gap-y-10 lg:flex-row gap-x-12 justify-between px-6 sm:px-[10%]">
                        <div className="flex flex-col items-center lg:items-start">
                            <div className="rounded-full h-40 w-40 sm:h-52 sm:w-52 overflow-clip mb-8 sm:mb-12 shadow-lg border-4 border-white">
                                <img src={dave} className="w-full h-full object-cover" alt="Dave Norton, RE/MAX Jazz" />
                            </div>
                            <p className="italic font-normal text-xl sm:text-2xl text-med-grey max-w-[600px] pb-4 text-center lg:text-left">
                                "This platform doubled my business in just eight months!"
                            </p>
                            <p className="text-lg sm:text-xl text-deep-grey text-center lg:text-left">
                                – Dave Norton, RE/MAX Jazz
                            </p>
                        </div>
                        <div className="text-center lg:text-right md:pt-16">
                            <h2 className={`mont md:text-5xl text-4xl text-med-grey font-normal pb-6 md:pb-10 ${windowSize <= 768 ? 'animate-fade-in' : 'slide-right duration-1000'}`}>
                                Proven Success & Happy Clients
                            </h2>
                            <p className={`text-xl md:text-2xl text-deep-grey ${windowSize <= 768 ? 'animate-fade-in delay-300' : 'slide-right duration-1500'}`}>
                                Trusted by <span className="font-normal text-logo-first text-4xl md:text-6xl">100+</span> Real Estate Professionals
                            </p>
                        </div>
                    </div>
                </section>

                {/* How It Works Section */}
                <section className="pb-20 px-6">
                    <h2 className="mont text-3xl md:text-5xl text-deep-grey font-normal pb-10 text-center">How It Works</h2>
                    <div id="features" className="mx-auto max-w-[1200px] flex flex-col gap-y-16 md:gap-y-24">
                        <div className="grid md:grid-cols-[60%_40%] gap-x-8 md:gap-x-24 gap-y-10 opacity-20 slide-up duration-1000">
                            <div className="border-l-[3px] border-l-logo-first pl-6 md:pl-10 relative min-h-[240px] md:min-h-[300px]">
                                <p className="vertical text-logo-first uppercase">Capture</p>
                                <p className="text-4xl md:text-5xl text-logo-first">01</p>
                                <div className="absolute bottom-0">
                                    <h3 className="md:text-3xl text-xl text-deep-grey pb-4 md:pb-6">Capture Deals Effortlessly</h3>
                                    <p className="text-med-grey md:text-xl text-base">Sync with your CRM, website flow in
                                        automatically.</p>
                                </div>
                            </div>
                            <div className="flex justify-center">
                                <img src={magnet} className="w-[70%] md:w-[300px] opacity-20 slide-up duration-1000" alt="Lead capture magnet illustration" />
                            </div>
                        </div>

                        <div className="grid md:grid-cols-[40%_60%] gap-x-8 md:gap-x-24 gap-y-10 opacity-20 slide-up duration-1000">
                            <div className="flex justify-center md:order-1 order-2">
                                <img src={msgs} className="w-[70%] md:w-[300px] opacity-20 slide-up duration-1000" alt="Automated messaging illustration" />
                            </div>
                            <div className="border-l-[3px] border-l-logo-first pl-6 md:pl-10 relative min-h-[240px] md:min-h-[300px] md:order-2 order-1">
                                <p className="vertical text-logo-first uppercase">Engage</p>
                                <p className="text-4xl md:text-5xl text-logo-first">02</p>
                                <div className="absolute bottom-0">
                                    <h3 className="md:text-3xl text-xl text-deep-grey pb-4 md:pb-6">Engage Instantly</h3>
                                    <p className="text-med-grey md:text-xl text-base">Our automated messages make sure every client feels valued and engaged.</p>
                                </div>
                            </div>
                        </div>

                        <div className="grid md:grid-cols-[60%_40%] gap-x-8 md:gap-x-24 gap-y-10 opacity-20 slide-up duration-1000">
                            <div className="border-l-[3px] border-l-logo-first pl-6 md:pl-10 relative min-h-[240px] md:min-h-[300px]">
                                <p className="vertical text-logo-first uppercase">Convert</p>
                                <p className="text-4xl md:text-5xl text-logo-first">03</p>
                                <div className="absolute bottom-0">
                                    <h3 className="md:text-3xl text-xl text-deep-grey pb-4 md:pb-6">Convert More Clients, Stress-Free</h3>
                                    <p className="text-med-grey md:text-xl text-base">Follow-ups happen while you focus on closing deals.</p>
                                </div>
                            </div>
                            <div className="flex justify-center">
                                <img src={finance} className="w-[70%] md:w-[300px] opacity-20 slide-up duration-1000" alt="Financial growth and conversion illustration" />
                            </div>
                        </div>
                    </div>
                </section>

                {/* Why Real Estate Clients Section */}
                <section ref={details} className="pb-20 min-h-[700px] bg-light-grey px-6 md:px-10">
                    <h2 className="mont text-3xl md:text-5xl text-deep-grey font-normal text-center pb-6 md:pb-8 pt-16 md:pt-20">Why Real Estate Clients?</h2>
                    <h3 className="mont text-xl md:text-2xl text-med-grey font-normal italic text-center pb-12 md:pb-16">
                        Time is money in real estate, and nurturing relationships shouldn't slow you down.
                        Real Estate Clients helps you automate your client communications, so you never miss an
                        opportunity to engage.
                    </h3>

                    <div id="love" className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-x-16 md:gap-y-20 justify-center mx-auto max-w-[1500px]">
                        <div className="relative opacity-20 slide-up2 duration-1000 mt-10 bg-white/50 p-6 rounded-lg shadow-sm">
                            <GiCheckMark className="text-logo-first text-4xl mb-4" />
                            <h4 className="text-xl md:text-2xl font-normal text-deep-grey pb-4">Never Miss a Referral Again</h4>
                            <p className="font-medium text-med-grey">Follow-ups happen automatically, even while you're busy.</p>
                        </div>

                        <div className="relative opacity-20 slide-up2 duration-1000 mt-10 bg-white/50 p-6 rounded-lg shadow-sm">
                            <GiCheckMark className="text-logo-first text-4xl mb-4" />
                            <h4 className="text-xl md:text-2xl font-normal text-deep-grey pb-4">Personalized Communication</h4>
                            <p className="font-medium text-med-grey">Messages feel natural and engaging, not robotic.</p>
                        </div>

                        <div className="relative opacity-20 slide-up2 duration-1000 mt-10 bg-white/50 p-6 rounded-lg shadow-sm">
                            <GiCheckMark className="text-logo-first text-4xl mb-4" />
                            <h4 className="text-xl md:text-2xl font-normal text-deep-grey pb-4">Increase Referral &amp; Clients</h4>
                            <p className="font-medium text-med-grey">Stay memorable without being intrusive.</p>
                        </div>

                        <div className="relative opacity-20 slide-up2 duration-1000 mt-10 bg-white/50 p-6 rounded-lg shadow-sm">
                            <GiCheckMark className="text-logo-first text-4xl mb-4" />
                            <h4 className="text-xl md:text-2xl font-normal text-deep-grey pb-4">Effortless Automation</h4>
                            <p className="font-medium text-med-grey">Set it up once, and let it handle outreach while you focus on closing deals.</p>
                        </div>
                    </div>
                </section>

                {/* Feature Carousel Section */}
                <section className="main-block-2 flex flex-wrap gap-8 md:gap-16 justify-center md:justify-between overflow-clip px-4 py-12 md:py-20">
                    <div className="flex flex-col gap-y-5 md:gap-y-7 mt-6 max-w-[600px]">
                        <h2 id="slide" className={`mont text-2xl md:text-[2.5rem] ${windowSize <= 768 ? 'opacity-0 animate-fade-in' : 'opacity-20 text-logo-first font-normal slide-in slide-left duration-1500'} text-center md:text-left`} style={{ minHeight: windowSize <= 768 ? '2.5rem' : 'auto' }}>
                            More Than a CRM.
                        </h2>
                        <h2 className={`mont text-2xl md:text-[2.5rem] ${windowSize <= 768 ? 'opacity-0 animate-fade-in delay-200' : 'opacity-20 text-logo-first font-normal slide-in slide-left duration-1500'} text-center md:text-left`} style={{ minHeight: windowSize <= 768 ? '2.5rem' : 'auto' }}>
                            More Than a Marketing Tool.
                        </h2>
                        <h2 className={`mont text-2xl md:text-[2.5rem] ${windowSize <= 768 ? 'opacity-0 animate-fade-in delay-400' : 'opacity-20 text-logo-first child:text-deep-grey font-normal slide-in slide-left duration-1500'} text-center md:text-left`} style={{ minHeight: windowSize <= 768 ? '2.5rem' : 'auto' }}>
                            A Real Estate <span className="font-semibold italic duration-1500">Growth</span> Machine.
                        </h2>
                        <button onClick={() => demoRef.current?.scrollIntoView({ behavior: 'smooth' })}
                            className={`btn-primary self-center md:self-start ${windowSize <= 768 ? 'animate-fade-in delay-600' : 'min-[1300px]:opacity-0 duration-3000 slide-in'} mt-8`}>
                            Book A Live Demo
                        </button>
                    </div>
                    <div className="mt-8 md:mt-0">
                        <EmblaCarousel />
                    </div>
                </section>

                {/* Pricing Section */}
                <section className="main-block px-4 md:px-10 py-16 md:py-20">
                    <h2 className="mont text-3xl md:text-5xl text-deep-grey font-normal text-center pb-4 md:pb-6">
                        Affordable Pricing for Every Agent &amp; Team
                    </h2>
                    <h3 className="mont text-xl md:text-2xl text-med-grey font-normal italic text-center pb-10">
                        Scale As You Grow
                    </h3>

                    <div className="max-w-4xl mx-auto">
                        <div className="flex flex-col md:flex-row items-center justify-between gap-8 md:gap-16 mb-10">
                            <div className="text-center md:text-left">
                                <div className="flex items-baseline justify-center md:justify-start mb-2">
                                    <span className="text-6xl font-bold text-logo-first">$99</span>
                                    <span className="text-2xl font-medium text-logo-first">.99</span>
                                    <span className="text-xl text-med-grey font-normal ml-2">/month</span>
                                </div>
                                <p className="text-med-grey text-lg">Full-featured platform access</p>
                            </div>

                            <div className="w-full md:w-auto">
                                <button
                                    className="w-full md:w-auto px-10 py-4 rounded-lg bg-gradient-to-r from-logo-first to-logo-third text-white font-bold text-lg transition-all duration-500 shadow-lg hover:shadow-xl"
                                    style={{
                                        transitionProperty: 'background-position, box-shadow, transform',
                                        backgroundSize: '200% 100%',
                                        backgroundPosition: 'right center',
                                        border: '2px solid rgba(255,255,255,0.3)',
                                        textShadow: '0px 1px 2px rgba(0,0,0,0.2)',
                                        position: 'relative',
                                        zIndex: 1,
                                        overflow: 'hidden',
                                    }}
                                    onMouseEnter={e => {
                                        e.currentTarget.style.backgroundPosition = 'left center';
                                        e.currentTarget.style.transform = 'translateY(-2px)';
                                    }}
                                    onMouseLeave={e => {
                                        e.currentTarget.style.backgroundPosition = 'right center';
                                        e.currentTarget.style.transform = 'translateY(0)';
                                    }}
                                    onClick={() => quoteFormRef.current?.scrollIntoView({ behavior: 'smooth' })}
                                >
                                    <span className="flex items-center justify-center gap-2 text-white">
                                        Contact Us For Details
                                        <FontAwesomeIcon icon={faAngleRight} className="transition-transform group-hover:translate-x-1" />
                                    </span>
                                </button>
                            </div>
                        </div>

                        {/* Divider */}
                        <div className="w-full h-px bg-gray-200 my-10"></div>

                        {/* Features in columns */}
                        <div className="grid md:grid-cols-2 gap-x-16 gap-y-6 max-w-3xl mx-auto">
                            <div className="flex items-start gap-3">
                                <GiCheckMark className="text-green-500 text-xl mt-0.5" />
                                <div>
                                    <h4 className="font-medium text-lg text-deep-grey">40+ Touchpoints</h4>
                                    <p className="text-med-grey">Engage clients regularly with strategic communications</p>
                                </div>
                            </div>
                            <div className="flex items-start gap-3">
                                <GiCheckMark className="text-green-500 text-xl mt-0.5" />
                                <div>
                                    <h4 className="font-medium text-lg text-deep-grey">Personalized Client Messaging</h4>
                                    <p className="text-med-grey">Custom messages that feel human and authentic</p>
                                </div>
                            </div>
                            <div className="flex items-start gap-3">
                                <GiCheckMark className="text-green-500 text-xl mt-0.5" />
                                <div>
                                    <h4 className="font-medium text-lg text-deep-grey">Advanced Analytics & Insights</h4>
                                    <p className="text-med-grey">Track engagement and nurture high-potential leads</p>
                                </div>
                            </div>
                            <div className="flex items-start gap-3">
                                <GiCheckMark className="text-green-500 text-xl mt-0.5" />
                                <div>
                                    <h4 className="font-medium text-lg text-deep-grey">Customizable Campaigns</h4>
                                    <p className="text-med-grey">Tailor workflows to your business needs</p>
                                </div>
                            </div>
                            <div className="flex items-start gap-3">
                                <GiCheckMark className="text-green-500 text-xl mt-0.5" />
                                <div>
                                    <h4 className="font-medium text-lg text-deep-grey">White-label & Team Solutions</h4>
                                    <p className="text-med-grey">Scale with branded materials for your entire team</p>
                                </div>
                            </div>
                            <div className="flex items-start gap-3">
                                <GiCheckMark className="text-green-500 text-xl mt-0.5" />
                                <div>
                                    <h4 className="font-medium text-lg text-deep-grey">Free Implementation</h4>
                                    <p className="text-med-grey">Professional setup and onboarding included</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                {/* Testimonials Section */}
                <section ref={test} className="bg-light-grey px-4 md:px-10 py-16 md:py-20">
                    <h2 className="mont text-3xl md:text-5xl text-deep-grey font-normal text-center pb-4 md:pb-6">What Our Clients Are Saying</h2>
                    <h3 className="mont text-xl md:text-2xl text-med-grey font-normal italic text-center pb-8 md:pb-10">Real Results from Real Agents</h3>

                    <div className="grid sm:grid-cols-1 md:grid-cols-2 gap-8 md:gap-16 max-w-[1200px] mx-auto">
                        {testimonials.map((agent) => (
                            <div key={agent.name} className="duration-700 relative diffuse-shadow bg-white text-deep-grey group rounded-xl transform hover:translate-y-[-5px] transition-all">
                                <div className="flex flex-col p-6 gap-4 w-full pb-8 relative">
                                    <div className="flex justify-between items-center">
                                        <RiDoubleQuotesL className="text-5xl md:text-7xl text-logo-second" />
                                        <div className="h-28 w-28 md:h-36 md:w-36 rounded-bl-full overflow-hidden z-10 shadow-md">
                                            <img
                                                style={{ objectPosition: '20% 0' }}
                                                className="w-full h-full object-cover"
                                                src={agent.img}
                                                alt={`${agent.name} - ${agent.title}`}
                                            />
                                        </div>
                                    </div>
                                    <blockquote className="text-base md:text-lg font-normal text-med-grey italic pt-6">{agent.quote}</blockquote>
                                    <p className="text-lg md:text-xl text-deep-grey mont font-semibold pt-3">{agent.name}</p>
                                    <p className="text-sm md:text-md text-deep-grey -mt-3">{agent.title}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </section>

                {/* About Us Section */}
                <section ref={about} className="px-6 md:px-10 py-16 md:py-20 max-w-[1500px] mx-auto">
                    <h2 className="mont text-3xl md:text-5xl text-deep-grey font-normal text-center pb-4 md:pb-6">About Us</h2>
                    <h3 className="mont text-xl md:text-2xl text-med-grey font-normal italic text-center pb-8 md:pb-6">
                        <span className="font-semibold">Transforming Client Relationships into Lifelong Success</span>
                    </h3>

                    <div className="flex flex-col md:flex-row gap-8 md:gap-16 pt-8 md:pt-16">
                        <img
                            src={clients}
                            className="w-full md:w-[40%] max-h-[300px] md:max-h-[350px] object-cover self-start rounded-lg md:rounded-br-[100px]"
                            alt="Real estate professionals collaborating"
                        />
                        <div>
                            <p style={{ lineHeight: '1.75em' }} className="text-med-grey font-normal text-base md:text-lg">
                                With over 15 years in the real estate industry, Real Estate Clients brings
                                expertise in client retention and business growth. Using industry
                                knowledge and a vast professional network, we provide strategies that drive long-term success
                                for realtors.<br /><br />
                                Unlike traditional tools, Real Estate Clients goes beyond simple client management. Our
                                platform turns your database into a continuous source of business by strengthening client
                                relationships and maximizing profitability.
                            </p>
                        </div>
                    </div>

                    <div className="grid sm:grid-cols-1 md:grid-cols-2 gap-8 md:gap-16 pt-12 md:pt-16">
                        <div className="bg-light-grey p-6 md:p-8 rounded-lg">
                            <h4 className="mont text-xl md:text-2xl text-deep-grey font-semibold pb-4 md:pb-6">Our Mission</h4>
                            <p style={{ lineHeight: '1.75em' }} className="text-med-grey font-normal">
                                We believe real estate success isn't just getting leads, it's equally important to nurture past clients.
                                That's why we've built a solution that automates the hard work, ensuring you stay connected
                                with clients, close more deals, and grow your business effortlessly.
                            </p>
                        </div>
                        <div className="bg-light-grey p-6 md:p-8 rounded-lg">
                            <h4 className="mont text-xl md:text-2xl text-deep-grey font-semibold pb-4 md:pb-6">Our Vision</h4>
                            <p style={{ lineHeight: '1.75em' }} className="text-med-grey font-normal">
                                To be the ultimate partner for real estate professionals, helping them stay organized, engaged,
                                and ahead of the competition, from the first interaction to years beyond the sale.
                            </p>
                        </div>
                    </div>
                </section>

                {/* Demo and Contact Section */}
                <section className="main-block from-logo-first/10 to-logo-third/10 grid grid-cols-1 lg:grid-cols-2 gap-10 items-start px-4 py-16 md:py-20">
                    <div ref={demoRef} className="w-full">
                        <div className="w-full max-w-3xl bg-white rounded-xl shadow-2xl p-8 mx-auto border-t-4 border-logo-first transition-all hover:shadow-xl">
                            <h2 className="text-3xl font-bold text-logo-first mb-4 text-center">Book a Demo</h2>
                            <div className="w-16 h-1 bg-logo-first mx-auto mb-6"></div>
                            <p className="text-med-grey mb-8 text-center">Schedule a personalized live demo to see how Real Estate Clients can transform your business</p>
                            <div
                                ref={calendlyRef}
                                className="calendly-inline-widget w-full rounded-lg overflow-hidden border border-gray-200"
                                data-url="https://calendly.com/milantheman23?hide_landing_page_details=1&text_color=333333&primary_color=1D5C96"
                                style={{ height: calendlyHeight }}
                            ></div>
                        </div>
                    </div>

                    <div ref={quoteFormRef} className="w-full">
                        <div className="max-w-lg w-full bg-white rounded-xl shadow-2xl p-10 mx-auto border-t-4 border-logo-first transition-all hover:shadow-xl">
                            <h2 className="text-3xl font-bold text-logo-first mb-4 text-center">Contact Us</h2>
                            <div className="w-16 h-1 bg-logo-first mx-auto mb-6"></div>
                            <p className="text-med-grey mb-8 text-center">Have questions or need help? Reach out to our team and we'll get back to you promptly.</p>
                            <form className="space-y-6" onSubmit={handleSubmit(onSubmitQuote)}>
                                <div>
                                    <label className="block text-md font-medium text-deep-grey mb-1">
                                        Name <span className="text-logo-first">*</span>
                                    </label>
                                    <input
                                        className={`form-input w-full px-4 py-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-logo-first ${errors.name ? 'border-red-400' : 'border-gray-300'} transition-all`}
                                        type="text"
                                        {...register('name', { required: 'Name is required' })}
                                        placeholder="Your name"
                                        disabled={isSubmitting}
                                    />
                                    {errors.name && <p className="text-sm text-red-500 mt-1">{errors.name.message}</p>}
                                </div>
                                <div>
                                    <label className="block text-md font-medium text-deep-grey mb-1">
                                        Company Name <span className="text-logo-first">*</span>
                                    </label>
                                    <input
                                        className={`form-input w-full px-4 py-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-logo-first ${errors.company ? 'border-red-400' : 'border-gray-300'} transition-all`}
                                        type="text"
                                        {...register('company', { required: 'Company name is required' })}
                                        placeholder="Your company name"
                                        disabled={isSubmitting}
                                    />
                                    {errors.company && <p className="text-sm text-red-500 mt-1">{errors.company.message}</p>}
                                </div>
                                <div>
                                    <label className="block text-md font-medium text-deep-grey mb-1">
                                        Email <span className="text-logo-first">*</span>
                                    </label>
                                    <input
                                        className={`form-input w-full px-4 py-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-logo-first ${errors.email ? 'border-red-400' : 'border-gray-300'} transition-all`}
                                        type="email"
                                        {...register('email', {
                                            required: 'Email is required',
                                            pattern: { value: /^\S+@\S+$/i, message: 'Invalid email address' }
                                        })}
                                        placeholder="Your email address"
                                        disabled={isSubmitting}
                                    />
                                    {errors.email && <p className="text-sm text-red-500 mt-1">{errors.email.message}</p>}
                                </div>
                                <div>
                                    <label className="block text-md font-medium text-deep-grey mb-1">
                                        Phone <span className="text-logo-first text-sm">(Optional)</span>
                                    </label>
                                    <input
                                        className={`form-input w-full px-4 py-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-logo-first ${errors.phone ? 'border-red-400' : 'border-gray-300'} transition-all`}
                                        type="tel"
                                        {...register('phone')}
                                        placeholder="Your phone number"
                                        disabled={isSubmitting}
                                    />
                                    {errors.phone && <p className="text-sm text-red-500 mt-1">{errors.phone.message}</p>}
                                </div>
                                <div>
                                    <label className="block text-md font-medium text-deep-grey mb-1">
                                        Message <span className="text-logo-first text-sm">(Optional)</span>
                                    </label>
                                    <textarea
                                        className={`form-input w-full px-4 py-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-logo-first ${errors.message ? 'border-red-400' : 'border-gray-300'} transition-all`}
                                        rows={4}
                                        {...register('message')}
                                        placeholder="How can we help you today?"
                                        disabled={isSubmitting}
                                    />
                                    {errors.message && <p className="text-sm text-red-500 mt-1">{errors.message.message}</p>}
                                </div>
                                <button
                                    type="submit"
                                    className="w-full py-3 rounded-lg bg-gradient-to-r btn-primary text-white font-semibold text-lg hover:from-logo-third hover:to-logo-first transition-all duration-300 disabled:opacity-60 shadow-md"
                                    disabled={isSubmitting}
                                >
                                    {isSubmitting ? 'Sending...' : 'Send Message'}
                                </button>
                                {success && (
                                    <div className={`mt-4 p-3 rounded-lg text-center text-lg ${success.startsWith('Your') ? 'bg-green-50 text-green-700' : 'bg-red-50 text-red-700'}`}>
                                        {success}
                                    </div>
                                )}
                            </form>
                        </div>
                    </div>
                </section>

                {/* Footer */}
                <footer className="bg-med-grey py-10 px-6 md:px-10">
                    <h2 className="mont text-xl md:text-2xl text-white font-semibold text-center mb-8">Our Clients</h2>

                    <div className="pricing-Swiper-Wrapper max-w-[1800px] mx-auto">
                        <Swiper
                            slidesPerView={2}
                            spaceBetween={30}
                            pagination={{
                                clickable: true,
                            }}
                            loop={true}
                            loopPreventsSliding={true}
                            loopedSlides={brandLogos.length - 3}
                            autoplay={{
                                delay: 3000,
                            }}
                            modules={[Pagination, auto]}
                            breakpoints={{
                                375: {
                                    spaceBetween: 30,
                                    slidesPerView: 2
                                },
                                550: {
                                    spaceBetween: 50,
                                    slidesPerView: 2
                                },
                                850: {
                                    spaceBetween: 100,
                                    slidesPerView: 3
                                },
                                1200: {
                                    spaceBetween: 120,
                                    slidesPerView: 4
                                },
                                1800: {
                                    spaceBetween: 200,
                                    slidesPerView: 4
                                }
                            }}
                            className="pb-10"
                        >
                            {brandLogos.map((logo, index) => (
                                <SwiperSlide key={index}>
                                    <div className="pricing-swipe-slide p-4 flex items-center justify-center h-[80px]">
                                        <img src={logo} className="max-h-full max-w-full object-contain" alt={`Client logo ${index + 1}`} />
                                    </div>
                                </SwiperSlide>
                            ))}
                        </Swiper>
                    </div>

                    <div className="pt-8 mt-8 border-t border-white/20">
                        <div className="flex flex-wrap gap-4 items-center justify-center md:justify-start">
                            <h3 className="mont text-xl md:text-2xl text-white font-normal">In Association With</h3>
                            <img src={nar} className="h-8 md:h-10" alt="National Association of Realtors Logo" />
                        </div>
                    </div>
                </footer>
            </main>
        </div>
    )
}